import { createContext } from "react";

const CatalogContext = createContext(null);

export default CatalogContext;
